import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  EXCLUSIVE_ROUTING_ANSWER_WARNING,
  EXCLUSIVE_ROUTING_ANSWER_WARNING_SHORT,
} from '@/features/instruments/domain/routing'

const EXCLUSIVE_ROUTING_WARNING_COLOR = '#b45309'

interface Props {
  readonly variant: 'full' | 'short'
  readonly testId: string
}

export function ExclusiveRoutingAnswerWarning({ variant, testId }: Props) {
  return (
    <Box
      role="note"
      data-testid={testId}
      sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', py: 0.5 }}
    >
      <WarningAmberOutlinedIcon
        sx={{
          color: EXCLUSIVE_ROUTING_WARNING_COLOR,
          fontSize: 14,
          mt: '2px',
          flexShrink: 0,
        }}
        aria-hidden
      />
      <Typography
        sx={{
          flex: 1,
          minWidth: 0,
          color: EXCLUSIVE_ROUTING_WARNING_COLOR,
          fontWeight: 600,
          fontSize: '13px',
          lineHeight: '19.5px',
          wordBreak: 'break-word',
        }}
      >
        {variant === 'full'
          ? EXCLUSIVE_ROUTING_ANSWER_WARNING
          : EXCLUSIVE_ROUTING_ANSWER_WARNING_SHORT}
      </Typography>
    </Box>
  )
}
